export const WIN_SIZE_MIN = 60;


// WEBPACK FOOTER //
// ./src/components/windowed/WindowConfig.js